/**
 * DANDU Unified B V1.1 — additive layout & surface roles.
 * Teacher/homepage is intentionally NOT a design reference.
 * No global MUI theme mutation; early adopters opt in explicitly.
 */
export const unifiedUI = Object.freeze({
  ink: '#17213C',
  secondary: '#45556D',
  purple: '#6546BF',
  purpleSurface: '#F5F1FF',
  border: '#E4E8F2',
  surface: '#FFFFFF',
  surfaceSubtle: '#F8F9FD',
  radius: 14,
  radiusLarge: 18,
  mainAction: {
    bgcolor: '#6546BF',
    color: '#FFFFFF',
    minHeight: 44,
    borderRadius: '10px',
    fontWeight: 600,
    textTransform: 'none',
    '&:hover': { bgcolor: '#5336AA' },
    '&:focus-visible': { outline: '3px solid #5336AA', outlineOffset: '3px' },
  },
  surfaceCard: {
    bgcolor: '#FFFFFF',
    border: '1px solid #E4E8F2',
    borderRadius: '14px',
    boxShadow: '0 4px 16px rgba(38,32,78,0.035)',
    minWidth: 0,
  },
});
export const formatTrCount = value => Number(value || 0).toLocaleString('tr-TR');
